export default "__VITE_ASSET__Vko_n3DR__ 640w, __VITE_ASSET__CjWrHFNL__ 1024w, __VITE_ASSET__T7hjAtfH__ 1920w";